export const PARALLEL_GRACE_PERIOD_MS = 5000;
export const generateBriefQueryKey = 'generateBrief';
export const pollGenerationQueryKey = 'pollGeneration';
export const classifyAdditionalDataQueryKey = 'classifyAdditionalData';
export const pollExtractAdditionalDataQueryKey = 'pollExtractAdditionalData';
export const UNABLE_TO_PRODUCE_A_BRIEF = 'unable_to_produce_a_brief';
export const MIME_TO_EXTENSION: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/svg+xml': 'svg',
    'application/pdf': 'pdf',
    'video/mp4': 'mp4',
    'video/quicktime': 'mov',
    'video/webm': 'webm',
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'audio/ogg': 'ogg',
    'text/plain': 'txt',
    'application/zip': 'zip',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
};
